import { get, ref } from "firebase/database"
import { useEffect, useState } from "react"
import { realtimeDatabase } from "services/firebase/firebase.service"
export default function useRealtimeSnapshot(node: string) {
  const [data, setData] = useState({})
  useEffect(() => {
    get(ref(realtimeDatabase, node)).then(snapshot => {
      setData(snapshot.val())
    })
  }, [node])

  // Return the data
  return { data }
}
